import { barChartColors, colorByVariant } from "@/helper/chart/constants/chart.const";
import { Variant } from "@/helper/chart/types/chart.type";

type DoughnutChartParam = {
  showLabel?: boolean;
  variant?: Variant;
  roseType?: "radius" | "area";
  barColors?: string[];
};

export const doughnutChartConfig = ({
  showLabel = false,
  variant = "primary",
  roseType,
  barColors = barChartColors,
}: DoughnutChartParam) => {
  return {
    title: {
      top: 0,
      left: 0,
      textStyle: {
        color: colorByVariant[variant],
        fontSize: 12,
        lineHeight: 15,
      },
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      right: -5,
      top: "middle",
      icon: "circle",
      selectedMode: true,
      itemHeight: 10,
      itemGap: 11,
      textStyle: {
        rich: {
          name: { fontSize: 10, fontWeight: 700, lineHeight: 12, color: "#25292D" },
          val: { fontSize: 8, fontWeight: 700, lineHeight: 10, color: "#555E68" },
        },
        height: 25,
      },
    },
    grid: {
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      containLabel: true,
    },
    series: [
      {
        type: "pie",
        color: barColors,
        radius: ["50%", "90%"],
        center: ["28.5%", "49.5%"],
        roseType,
        startAngle: 90,
        clockwise: true,
        avoidLabelOverlap: true,
        label: {
          show: showLabel,
          color: colorByVariant[variant],
        },
        labelLine: {
          lineStyle: {
            color: colorByVariant[variant],
          },
        },
        animationType: "scale",
        animationEasing: "elasticOut",
        animationDelay: function () {
          return Math.random() * 200;
        },
        itemStyle: {
          borderColor: "#ffffff",
          borderWidth: 2,
        },
        emphasis: { scale: true, distance: 3 },
      },
    ],
  };
};
